export const HTTPURL = process.env.REACT_APP_API_URL;
export const STUDENT_PORTAL_URL = process.env.REACT_APP_STUDENT_PORTAL_URL;
export const StripePublicKey = "pk_test_51Qoex5Rx5fB3S6g6Aq6caXBELuFFGRKUWjdQxvgYVdpRA0bN7yjQQAdl9NcGlUP06rUwB9Y8pT1tWXAa5q8f2RtR00a4YrOpd1";
